import moment from 'moment';
import Dashboard from "./dashboard";
import Google from "./google";






 


class Member{
   constructor(params,o=false){
    this.accountType = "Analytics";
      this._types = {
          "dashboard":Dashboard,
          "google":Google,
          "analytics":Member
      }
      this.generic = {
         id:false,
         accountType:"Member",
         name:"",
         subTitle:"",
         description:"Client",
         icon:"demo-icon simple-icon-user"
     }
  
    this.setParameters(o);
         

    
             
   for (var t of  Object.keys(this._types)){
       if (params.permissionsTable[this.accountType+"-"+t.charAt(0).toUpperCase()+t.slice(1)]){
         for (var pt of params.permissionsTable[this.accountType+"-"+t.charAt(0).toUpperCase()+t.slice(1)]){
           if (pt.objectIds.indexOf(this.id) > -1){
             for (var oid of pt.pivotObjectIds){
                params.accounts[pt.pivotAccountId][oid].filter = this.networkConnections;
               var model = new this._types[t](params,params.accounts[pt.pivotAccountId][oid]);
               this.setModelParameters(model);
             }
           }
       }
     }
     }
        
}

          setParameters(params){
            for (var prop in params){
                if (params.hasOwnProperty(prop)){
                    var method = "set" + prop.charAt(0).toUpperCase() + prop.slice(1);
                    if (this[method]){
                      this[method](params[prop]);
                    }
                    else{
                     this[prop] = params[prop];
                    }
                    
                }
            }

        }

   setAccountType(val){
      this.accountType = val.charAt(0).toUpperCase()+val.slice(1);
   }

        
   setId(val){
      this.generic.id = val;
      this.id = val;
    }
    setFullName(str){
      this.generic.name = str;
      this.generic.label = str;
    }
    setValue(str){
      this.generic.subTitle = str;
    }
      
    setAnalyticsType(str){
      if (str && str != ""){
      this.generic.description = str;
      }
    }

    setModelParameters(params){
      var ac = (this.accountType == params.accountType) ? "Member" : params.accountType;
        this[params.accountType] = (this[params.accountType]) ? this[params.accountType] : [];
        this[params.accountType].push(params);
    }
  }
  export default Member;
            